import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription as RxSubscription } from 'rxjs';

import { CohortsDataSource } from '../../services/cohorts-data-source';

@Component({
    selector: 'cohorts-list-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class CohortsList implements OnInit, OnDestroy {
  public loading: boolean;
  public listingId: number;
  public displayedColumns = ['title', 'actions'];
  private Subscriptions: RxSubscription[] = [];
  public cohortLoading: number;

  constructor(
    protected dialogRef: MatDialogRef<CohortsList>,
    @Inject(MAT_DIALOG_DATA) public DataSource: CohortsDataSource
  ) {}

  ngOnInit() {
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((loading) => (this.loading = loading))
    );
    this.DataSource.load(this.DataSource);
  }

  public setCohorts(Cohorts) {
    this.cohortLoading = Cohorts.id;

    this.DataSource.save(Cohorts).then(() => (this.cohortLoading = 0));
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
